export default __webpack_public_path__ + "static/media/gm-net-girl.1f606da2.webp";